import * as React from 'react';
import styles from './style.css';

export interface IFooterProps {
  disclaimer?: string;
}

export const Footer: React.FC<IFooterProps> = ({ disclaimer }) => {
  return <span className={styles['footer']}>{disclaimer}</span>;
};
